import { buildLocaleRecord, Locales, ZeffyLandingPageUrl } from "@simplyk/common";

// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { BadgeVibe } from "@/dashboard-design-system/Badge";

export const FRONTEND_URL = process.env.NEXT_PUBLIC_FRONTEND_URL as string;
export const API_URL = process.env.NEXT_PUBLIC_API_URL as string;

const DEV_LOGIN_URL = process.env.NEXT_PUBLIC_FRONTEND_URL + "/login";

export const LandingPageUrl =
  process.env.NODE_ENV === "production"
    ? ZeffyLandingPageUrl
    : buildLocaleRecord({
        [Locales.EN]: DEV_LOGIN_URL,
        [Locales.FR]: DEV_LOGIN_URL,
        [Locales.ES]: DEV_LOGIN_URL,
        [Locales.DE]: DEV_LOGIN_URL,
      });

export enum SubMenu {
  Fundraising = "fundraising",
  Crm = "crm",
  Bank = "bank",
  Referral = "referral",
}

export enum SubMenuItem {
  Campaigns = "fundraising.campaigns",
  Payments = "fundraising.payments",
  Insights = "fundraising.insights",
  Receipts = "fundraising.receipts",
  Contacts = "crm.contacts",
  Emails = "crm.emails",
  Bank = "bank.overview",
  Payouts = "bank.payouts",
  Transactions = "bank.transactions",
  Balance = "bank.balance",
  NewsletterForms = "crm.forms",
  PostMail = "crm.postMail",
  ContactLists = "crm.lists",
}

export interface MenuItem {
  name: SubMenu | SubMenuItem;
  isActive: boolean;
  iconSrc?: React.FC<React.SVGProps<SVGSVGElement>>;
  isOpen?: boolean;
  path: string;
  items?: MenuItem[];
  openInNewTab?: boolean;
  isFeatureActivated: boolean;
  isFeatureAllowed: boolean;
  displayNotificationDot?: boolean;
  notificationDotVibe?: BadgeVibe;
  label?: string;
}
